<template>
    <span v-if="value && value.op !== 'and' && value.op !== 'or'">
        <span><span class="var">{{value.field ? value.field.split(':')[0] : ''}}</span> <span class="op">{{niceOp(value.op)}}</span> <span v-if="showVal(value.op)" class="val">{{cleanValue(value.field.split(':')[1], value.value)}}</span></span>
    </span>
    <span v-else-if="value" style="" class="">
        <span class="paren" v-if="depth > 1 && len(value.rules)">(</span>
        <span v-for="(rule,i) in value.rules">
            <RulePreview :depth="depth+1" :value="rule"></RulePreview>
            <span v-if="i !== value.rules.length - 1"> <span class="jop">{{value.op}}</span> </span>
        </span>
        <span class="paren"  v-if="depth > 1 && len(value.rules)">)</span>
    </span>
</template>
<style scoped>

span {
    display: inline-block;
    margin-top: 2px;
}

.paren {
    font-size: 1.2em;
}

.var {
    font-family: courier;    
    background-color: #ddf;
    padding: 3px 8px;
    border-radius: 8px;
}

.val {
    background-color: #fdf;
    padding: 3px 8px;
    border-radius: 8px;
}

.op {
}

.jop {
    color: #888;
    padding: 4px 6px;
}


</style>
<script>
import dayjs           from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat)

export default {
    name: 'RulePreview', 
    props: {
        value: [Object],
        depth: {
            type: Number,
            default: 1
        }
    },
    methods: {
        niceOp(op) {
            if ( op == '==' ) return 'is'
            else if ( op === '!=' ) return 'is not'
            else if (op === 'is_null') return 'is empty'
            else if (op === 'is_not_null') return 'is not empty'
            else if (op === 'starts_with') return 'starts with'
            else if (op === 'ends_with') return 'ends with'
            else return op

        },
        len(arr) {
            if ( !arr ) return false;
            return arr.length > 0;
        },
        cleanValue(type, val) {
            if ( type === 'TIMESTAMP' ) return dayjs(val).format('LLL')
            return val
        },
        showVal(op) {
            return !['is_null', 'is_not_null'].includes(op);
        }
    }
}
</script>

